"use client"
import {memo} from "react";
import {Info} from "lucide-react";
import { Link } from "react-router-dom";

function InformationsEssentiellesCard() {
    return (<div className={"text-center flex items-center justify-center gap-2 rounded-xl p-8 bg-infos bg-bottom text-2xl text-white font-exo"}>
        <Link to={"/guide-de-voyage/infos-utiles"} className={"cursor-pointer flex gap-2 items-center hover:scale-75 transition-all duration-500"}>
            <Info size={24} />
            Informations essentielles
        </Link>
    </div>)
}

export default memo(InformationsEssentiellesCard);
